<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品代码">
              <a-input
                placeholder="请输入产品代码"
                v-model="queryParam.fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="7" :md="10" :sm="24">
            <a-form-item label="起息日期">
              <a-range-picker
                :placeholder="['起息开始日期', '起息结束日期']"
                :value="createValue"
                @change="handleChange"
                format="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="11" :md="12" :sm="20">
              <a-form-item label="结息日期">
                <a-range-picker
                  @change="endDateChange"
                  :value="endCreateValue"
                  :placeholder="['结息开始日期', '结息结束日期']"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="审核状态">
                <j-dict-select-tag
                  placeholder="请选择审核状态"
                  v-model="queryParam.checkStatus"
                  dictCode="quotation_checkStatus"
                />
              </a-form-item>
            </a-col>

            <a-col :xl="8" :lg="7" :md="10" :sm="24">
              <a-form-item label="预期收益率" class="expected-rate">
                <!-- <a-range-picker :placeholder="['最小houyil','结息结束日期']"  /> -->
                <a-input
                  placeholder="请输入最小值"
                  class="query-group-cust"
                  v-model="queryParam.startExpectedYield"
                  style="width:41%"
                ></a-input>
                <span class="query-group-split-cust"></span>
                <a-input
                  placeholder="请输入最大值"
                  class="query-group-cust"
                  v-model="queryParam.endExpectedYield"
                  style="width:42%"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否导出">
                <j-dict-select-tag
                  placeholder="请选择是否导出"
                  v-model="queryParam.isExport"
                  dictCode="quotation_isExport"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button @click="showDialog = true" type="primary" icon="upload"
        >导入</a-button
      >
      <a-button
        type="primary"
        icon="download"
        @click="handleExportExcel('产品报价')"
        >导出</a-button
      >

      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
          <a-menu-item @click="handleBatchAudit">
            <a-icon type="plus" />批量审核
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <!-- 导入 -->
      <a-modal
        title="上传文件"
        :visible="showDialog"
        @cancel="showDialog = false"
      >
        <a-upload-dragger
          name="file"
          :multiple="true"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :remove="handleRemove"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或拖拽上传文件</p>
        </a-upload-dragger>
        <p
          @click="falling('报价管理模板')"
          style="float: right; margin-top: 0px; cursor: pointer; color: #1890ff"
        >
          点击下载模板
        </p>
        <template slot="footer">
          <a-button key="back" @click="showDialog = false"> 取消 </a-button>
          <a-button
            :disabled="fileList.length === 0"
            :loading="uploading"
            key="submit"
            type="primary"
            icon="download"
            @click="upload"
          >
            导入
          </a-button>
        </template>
      </a-modal>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a
            @click="handleAudit(record)"
            :class="record.checkStatus != '0' ? 'hasDisable' : ''"
            >审核</a
          >
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
              </a-menu-item> -->
          <!-- <a-menu-item> -->
          <a
            :disabled="record.checkStatus == 1 ? true : false"
            @click="handleDelete(record.id)"
          >
            删除
          </a>
          <!-- </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>

    <products-quotation-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></products-quotation-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JDate from '@/components/jeecg/JDate';
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ProductsQuotationModal from './modules/ProductsQuotationModal';
import { filterObj } from '@/utils/util';
import {
  uploadAction,
  postAction,
  getAction,
  downFiles,
  downFile
} from '@/api/manage';

export default {
  name: 'ProductsQuotationList',
  mixins: [mixinDevice],
  components: {
    JDate,
    ProductsQuotationModal
  },
  data() {
    return {
      description: '产品报价管理页面',
      fileList: [],
      showDialog: false,
      loading: false,
      showLead: false,
      uploading: false,
      selectedRowKeys: [],
      toggleSearchStatus: false,
      selectionRows: [],
      dataSource: [], //table数据
      endCreateValue: [],
      createValue: [],
      queryParam: {
        //查询数据
        fundCode: '',
        beginDate: '',
        checkStatus: undefined,
        endDate_begin: '',
        endDate_end: '',
        isExport: undefined,
        expectedYield: '',
        endDate: '',
        endExpectedYield: '',
        startExpectedYield: ''
      },
      endTime: [], //结息日期
      startTime: [], //起息日期
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '产品代码',
          align: 'center',
          sorter: true,
          dataIndex: 'fundCode'
        },
        {
          title: '收益率(%)',
          align: 'center',
          dataIndex: 'expectedYield',
          customRender: function(text) {
            return !text ? '--' : text + '%';
          }
        },
        {
          title: '起息日期',
          align: 'center',
          dataIndex: 'beginDate',
          customRender: function(text) {
            return !text ? '--' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '结息日期',
          align: 'center',
          dataIndex: 'endDate',
          customRender: function(text) {
            return !text ? '--' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '预期开放日',
          align: 'center',
          dataIndex: 'openDate',
          customRender: function(text) {
            return !text ? '--' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '到期日',
          align: 'center',
          dataIndex: 'dueDate',
          customRender: function(text) {
            return !text ? '--' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkStatus',
          customRender: text => {
            if (text == 0) {
              return '未审核';
            } else if (text == 1) {
              return '已审核';
            }
          }
        },
        {
          title: '是否导出',
          align: 'center',
          dataIndex: 'isExport',
          customRender: text => {
            if (text == 0) {
              return '未导出';
            } else if (text == 1) {
              return '已导出';
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/list',
        delete:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/deleteBatch',
        audit:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/audit',
        auditBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/auditBatch',
        derive:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productQuotation/derive',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/importExcel', //导入
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/exportXls', //导出
        exportsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/downExcelTemplate' //导出空模板
      },
      dictOptions: {},
      superFieldList: []
    };
  },
  created() {
    this.getSuperFieldList();
    this.getList();
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = [];
      fieldList.push({
        type: 'string',
        value: 'fundCode',
        text: '产品代码',
        dictCode: ''
      });
      fieldList.push({ type: 'date', value: 'beginDate', text: '起息日期' });
      fieldList.push({ type: 'date', value: 'endDate', text: '结息日期' });
      fieldList.push({ type: 'date', value: 'openDate', text: '预期开放日' });
      fieldList.push({ type: 'date', value: 'purchaseDate', text: '申购日' });
      fieldList.push({ type: 'date', value: 'redemptionDate', text: '赎回日' });
      fieldList.push({
        type: 'date',
        value: 'nextPurchaseDate',
        text: '下一个申购日'
      });
      fieldList.push({
        type: 'date',
        value: 'nextRedemptionDate',
        text: '下一个赎回日'
      });
      fieldList.push({
        type: 'date',
        value: 'nextOpenDate',
        text: '下一个开放日'
      });
      fieldList.push({
        type: 'string',
        value: 'checkStatus',
        text: '审核状态',
        dictCode: 'quotation_checkStatus'
      });
      fieldList.push({
        type: 'string',
        value: 'fundSonCode',
        text: '产品子代码',
        dictCode: ''
      });
      fieldList.push({
        type: 'string',
        value: 'fundDemand',
        text: '资金需求',
        dictCode: ''
      });
      fieldList.push({
        type: 'sel_search',
        value: 'fundDemandStatus',
        text: '资金需求状态',
        dictTable: '',
        dictText: '',
        dictCode: ''
      });
      fieldList.push({
        type: 'date',
        value: 'issueBeginDate',
        text: '发行开始日'
      });
      fieldList.push({
        type: 'date',
        value: 'issueEndDate',
        text: '发行截止日'
      });
      fieldList.push({
        type: 'string',
        value: 'issueNumber',
        text: '发行天数',
        dictCode: ''
      });
      fieldList.push({ type: 'date', value: 'dueDate', text: '到期日' });
      fieldList.push({
        type: 'string',
        value: 'pledgeNote',
        text: '质押备注',
        dictCode: ''
      });
      fieldList.push({
        type: 'string',
        value: 'isExport',
        text: '是否导出',
        dictCode: 'quotation_isExport'
      });
      fieldList.push({
        type: 'string',
        value: 'expectedYield',
        text: '预期收益率',
        dictCode: ''
      });
      this.superFieldList = fieldList;
    },
    channel() {
      this.showDialog = true;
    },

    //excel转换
    productToLead() {
      this.showLead = true;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    //上传
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 批量审核
    handleBatchAudit: function() {
      if (!this.url.auditBatch) {
        this.$message.error('请设置url.checkSuccess属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '提示',
          content: '确定对勾选数据进行审核吗?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.auditBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;

      console.log(this.selectionRows, '>>>>');
    },
    // 获取数据
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      getAction(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.list;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let endTime = this.endTime;
      let param = Object.assign(sqp, this.queryParam, this.isorter, endTime);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      let isHasReview = this.selectionRows.some(item => {
        return item.checkStatus == 1;
      });
      if (isHasReview) {
        this.$message.warning('已审核的数据不能删除');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.createValue = [];
      this.endCreateValue = [];
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //单条审核
    handleAudit(record) {
      if (record.checkStatus != '0') {
        return;
      }
      let that = this;
      this.$confirm({
        title: '提示',
        content: '确定对此数据进行审核吗？',
        onOk: function() {
          that.loading = true;
          getAction(
            process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/audit',
            { id: record.id }
          ).then(res => {
            if (res.success) {
              console.log('-----------' + res.message);
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
              that.getList();
            }
          });
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    // 导出excel
    handleExportExcel(fileName) {
      let derive = [];
      if (this.selectionRows.length <= 0) {
        return this.$message.warning('请选择数据');
      }
      let index = this.selectionRows.findIndex(item => item.checkStatus == '0');
      // this.selectionRows.forEach(item => {
      //   derive.push(item.checkStatus);
      // });
      if (index > -1) {
        this.$message.warning('选中的数据当前有未审核的数据,不能导出');
        return;
      } else {
        if (!fileName || typeof fileName != 'string') {
          fileName = '导出文件';
        }
        let param = { selections: this.selectedRowKeys.join(',') };
        // console.log('param', param);
        // let formData = new FormData();
        // formData.append('selections', '11111');
        // console.log(formData);
        downFiles(this.url.exportXlsUrl, param).then(data => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
            this.searchQuery();
          }
        });
      }
    },
    falling(fileName) {
      downFile(this.url.exportsUrl, { selections: '' }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xlsx'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.searchQuery();
        }
      });
    },
    //获取起息时间
    handleChange(date, dateStrings) {
      this.createValue = date;
      let startTime = dateStrings[0];
      let endTime = dateStrings[1];
      if (startTime == '' || endTime == '') {
        this.queryParam.valueDate = null;
      } else {
        this.queryParam.valueDate = startTime + '|' + endTime;
      }
      console.log(this.queryParam, dateStrings);
    },
    //获取结息时间
    endDateChange(date, dateStr) {
      this.endCreateValue = date;
      let startTime = dateStr[0];
      let endTime = dateStr[1];
      if (startTime == '' || endTime == '') {
        this.queryParam.interestSettlementDate = null;
      } else {
        this.queryParam.interestSettlementDate = startTime + '|' + endTime;
      }
      console.log(this.queryParam.endDate, dateStr);
    },
    audit() {},
    recheck() {}
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 82% !important;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control:hover {
  border-color: #40a9ff;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-children
  input {
  border: none;
  height: 28px;
}
/deep/.expected-rate.ant-form-item input:focus {
  box-shadow: none;
}
.delBtn {
  border: none;
  background-color: #ffffff;
}
</style>
